<template>
	<div>
		<b-breadcrumb :items="[
			{ text: this.customerName, to: '/' },
			{ text: 'Bill Audit' }
		]">
		</b-breadcrumb>
		<div class="d-flex justify-content-end mt-3 mb-2">
			<b-btn variant="primary" v-b-modal.report-modal>Nuovo report</b-btn>
			<b-btn class="ml-1" variant="primary" v-b-modal.upload-enerp-modal>Carica dati EnerP</b-btn>
			<b-btn class="ml-1" variant="primary" v-b-modal.upload-pod-modal>Carica curve</b-btn>
		</div>


		<BillAuditModal @created="refresh" ref="report-modal" />
		<InvoiceModal ref="invoice-modal" />
		<InvoiceAddModal ref="invoice-add-modal" @created="closeAddInvoiceModal" />
		<UploadEnerp @completed="onUploadCompleted" @uploading="onUploading" />
		<UploadPodModal @completed="onUploadPodCompleted" ref="upload-pod-modal" />

		<b-row>
			<b-col>
				<b-card>
					<table class="table striped table-hover">
						<thead>
							<tr>
								<th></th>
								<th>Sito</th>
								<th>Fornitore</th>
								<th>Periodo</th>
								<th>Punto di prelievo</th>
								<th>Autoproduzione</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in rows" :key="item.id">
								<td>{{ item.id }}</td>
								<td>{{ item.siteName }}</td>
								<td>{{ item.supplier }}</td>
								<td>{{ item.timeSpan }}</td>
								<td>{{ item.supplyChannelName }}</td>
								<td>{{ item.selfProductionChannelName }}</td>
								<td>
									<div class="d-flex justify-content-end">
										<b-btn title="Visualizza" class="mr-2">
											<router-link :to="`/bill-audit/view/${item.id}`" tag="span">
												<font-awesome-icon icon="eye" />
											</router-link>
										</b-btn>
										<b-btn title="Scarica" class="mr-2">
											<font-awesome-icon icon="download" />
										</b-btn>
										<template v-if="isSuperAdmin">
											<b-btn title="Modifica" class="mr-2" @click="edit(item)">
												<font-awesome-icon icon="cogs" />
											</b-btn>
											<b-btn title="Dati fattura" class="mr-2" @click="loadInvoiceData(item)">
												<font-awesome-icon icon="file-invoice" />
											</b-btn>
											<b-btn title="Aggiungi dati fattura" class="mr-2"
												@click="showAddInvoiceModal(item)">
												<font-awesome-icon icon="file-invoice" />
												<font-awesome-icon icon="plus" />
											</b-btn>
											<b-btn title="Elimina" variant="danger" @click="confirmDelete(item)">
												<font-awesome-icon icon="fa-times" />
											</b-btn>
										</template>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</b-card>
			</b-col>
		</b-row>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import BillAuditModal from './Modals/BillAuditModal.vue';
import UploadEnerp from './UploadEnerp.vue';
import InvoiceModal from './Modals//InvoiceModal.vue';
import InvoiceAddModal from './Modals/InvoiceAddModal.vue';
import UploadPodModal from './Modals/UploadPodModal.vue';

export default {
	name: "BillAuditList",
	components: { BillAuditModal, UploadEnerp, InvoiceModal, InvoiceAddModal, UploadPodModal },
	data() {
		return {
			list: [],
			showModal: false,
		}
	},
	created() {
		this.refresh()		
	},
	methods: {
		onUploading() {
			this.$store.commit("loading")
			this.$bvModal.hide('upload-enerp-modal')
		},
		onUploadCompleted() {
			this.$store.commit("stopLoading")		
			this.$notify({
				type: "success",
				text: "Dati importati"
			});
		},
		onUploadPodCompleted() {
			this.$bvModal.hide('upload-pod-modal')
		},
		async confirmDelete(report) {
			const msg = `Vuoi procedere con l'eliminazione del report ${report.id}?`
			const choice = await this.$bvModal.msgBoxConfirm(msg, {
				cancelTitle: 'Annulla',
				okTitle: 'Elimina',				
			})
			if (choice === true) {
				this.$store.commit("loading")
				await this.$store.dispatch('billaudit/delete', report.id)
				this.$store.commit("stopLoading")	
				this.refresh()
			}
		},
		async refresh() {
			this.$store.commit("loading")
			const data = await this.$store.dispatch('billaudit/list')
			this.$store.commit("stopLoading")
			this.list = data.map(e => {
				e.supplyChannelName = this.channelName(e.siteId, e.supplyChannelCode)
				e.selfProductionChannelName = this.channelName(e.siteId, e.selfProductionChannelCode)
				return e
			})
		},
		showAddInvoiceModal(report) {
			this.$refs['invoice-add-modal'].setBillAuditReportId(report.id)
			this.$bvModal.show('invoice-add-modal')
		},
		closeAddInvoiceModal() {
			this.$bvModal.hide('invoice-add-modal')
		},
		edit(report) {
			this.$refs['report-modal'].setData(report)
			this.$bvModal.show('report-modal')
		},
		async loadInvoiceData(report) {
			this.$store.commit("loading")
			const data = await this.$store.dispatch('billaudit/getInvoiceData', report.id)
			this.$refs['invoice-modal'].setData(data.data)
			this.$refs['invoice-modal'].setBillAuditReportId(report.id)
			this.$bvModal.show('invoice-modal')
			this.$store.commit("stopLoading")
		},
		formatMonth(monthRaw) {
			const year = `${monthRaw}`.substring(0, 4)
			const month = `${monthRaw}`.substring(4, 6)
			return `${month}/${year}`
		},
		channelName(siteId, channelCode) {
			console.log(siteId, channelCode)
			if (!channelCode) {
				return '--'
			}
			const channel = this.user.sites
				.find(site => site.id == siteId)
				.channels.find(channel => channel.code == channelCode)
			return channel ? channel.name : '--'
		}
	},
	computed: {
		rows() {
			return this.list.map(e => {
				const site = this.user.sites.find(s => s.id == e.siteId)
				e.siteName = site.name
				e.timeSpan = `${this.formatMonth(e.from)} - ${this.formatMonth(e.to)}`
				return e
			})
		},
		user() {
			return this.$store.state.user
		},
		customerName() {
			return this.user.customerName
		},
		isSuperAdmin() {
			return this.$store.state.user && this.$store.state.user.level == 1
		},
		...mapGetters({
			vectorName: "vectors/getName"
		}),
	}
}
</script>


// WEBPACK FOOTER //
// src/components/BillAudit/List.vue